import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "reactstrap";
import {
  emailNotificationsLoadingSelector,
  // emailNotificationsLoadingSelector,
  emailNotificationsSelector,
} from "../../selectors";
import { getEmailNotifications } from "../../actions";

import EmailNotificationsTable from "./email-notifications-table";
import "./emailNotifications.css";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const EmailNotificationsPage = () => {
  const emailNotifications = useSelector(emailNotificationsSelector);
  const isLoading = useSelector(emailNotificationsLoadingSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEmailNotifications());
  }, [emailNotificationsSelector]);

  return (
    <div>
      <PageTitle title="email notifications" />
      <FullscreenLoader loading={isLoading} />
      <Container
        className="email-notifications-main-container pl-0 pr-0"
        tabIndex="0"
      >
        {/* {isLoading ? <LargeSpinner loading={isLoading} /> : null} */}
        <EmailNotificationsTable emailNotifications={emailNotifications} />
      </Container>
    </div>
  );
};

export default EmailNotificationsPage;



// WEBPACK FOOTER //
// ./src/features/organization/pages/email-notifications/email-notifications-page.jsx